module.exports = __webpack_public_path__ + "f2704c0a295e64e1ee9d3349e2ba5872.MP3";